import React, { useState, useEffect, memo } from 'react';
import { cloneDeep } from 'lodash';
import { get } from 'lodash';
import { Button } from '@/src/components/Antd';
import ProductItemsTable from '../ProductsItems/ProductItemsTable';
import { Icon } from '@/src/tools/icon';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

enum UserSelectionType {
  None = 'None',
  Confirmed = 'Confirmed',
  Discarded = 'Discarded',
  Reselected = 'Reselected',
}

const DiscountSelections = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, form, reLoadDiscount, disabled, currency, keyUuid } =
    props;
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const {
    discount = {},
    giftSelection,
    remainingQuota,
    discountPrice,
    validFrom,
    validTo,
    applyTo,
    customerCondition,
    freeGift,
  } = value || {};
  const {
    maxSelection = 0,
    selectable,
    selectionType,
    products,
    userSelection,
  } = giftSelection || {};

  const { name = '', codes = [] } = discount || {};
  const [edit, setEdit] = useState(
    userSelection === UserSelectionType.Confirmed ? false : true,
  );
  const [productAll, setProductAll] = useState([]);
  const checkedProduct = productAll.filter((o) => o.checked);
  const checkedProductUuids = checkedProduct.map((item) =>
    keyUuid ? item[keyUuid] : item.uuid,
  );
  const checkedAmount = checkedProduct.reduce((pre, now) => {
    return pre + Number(now.amount || 0);
  }, 0);
  useEffect(() => {
    setEdit(userSelection == UserSelectionType.Confirmed ? false : true);
    const _products = (products || []).map((item, index) => {
      return {
        ...item,
        //selectionType == 'Single'且之前没选择过的默认选中第一个，
        checked:
          (userSelection === UserSelectionType.None &&
            selectionType == 'Single' &&
            freeGift &&
            index == 0) ||
          item.checked,
      };
    });
    setProductAll(_products);
  }, [giftSelection]);

  const onSelectChange = (selectValue, select) => {
    const _product = cloneDeep(productAll || []);
    _product.forEach((item) => {
      if (selectValue.includes(keyUuid ? item[keyUuid] : item.uuid)) {
        item.checked = true;
        if (!item.amount) {
          item.amount = 1;
        }
      } else {
        item.checked = false;
      }
    });
    setProductAll(_product);
  };

  const rowSelection = {
    selectedRowKeys: checkedProductUuids,
    onChange: onSelectChange,
    type: selectionType == 'Single' ? 'radio' : 'checkbox',
    getCheckboxProps: (record) => {
      const productIndex = productAll.filter(
        (o) => o[keyUuid] == record[keyUuid],
      );
      const productIndexAmount = Number(get(productIndex, [0, 'amount'], 0))
        ? Number(get(productIndex, [0, 'amount'], 0))
        : 1;
      return {
        disabled:
          selectionType == 'Multi' &&
          maxSelection - checkedAmount - productIndexAmount < 0 &&
          !productIndex[0].checked,
        name: record.name,
      };
    },
  };

  const handleEdit = () => {
    setEdit(true);
  };

  const handleApply = () => {
    setEdit(false);
    onChange({
      ...value,
      giftSelection: {
        ...giftSelection,
        products: productAll,
        userSelection: 'Confirmed',
      },
    });
  };
  const handleProductChange = (_products) => {
    setProductAll(_products);
    onChange({
      ...value,
      giftSelection: {
        ...giftSelection,
        products: _products,
        //userSelection: 'Confirmed',
      },
    });
  };

  const handleDelete = (codes) => {
    const discountCodes = form.getFieldValue('discountCodes');
    const discountCodesAll = (discountCodes || []).filter(
      (o) => !codes.includes(o),
    );
    form.setFieldsValue({
      discountCodes: discountCodesAll,
    });
    reLoadDiscount();
  };

  return (
    <div className={css.promo}>
      <div className={css.promoValid}>
        <div>
          {getI18n(
            (codes || []).length
              ? 'allOrders.createneworder.component_discountselection_promocodevalid'
              : 'allOrders.createneworder.promoValid',
          )}
          {(codes || []).map((item, index) => (
            <span key={index} className={css.promoValidItem}>
              {item}
            </span>
          ))}
          {(applyTo || {}).conditionType && (
            <span className={css.promoValidItem}>
              {(applyTo || {}).conditionType}
            </span>
          )}
          {(customerCondition || {}).conditionType && (
            <span className={css.promoValidItem}>
              {(customerCondition || {}).conditionType || ''}
            </span>
          )}
        </div>
        {(codes || []).length ? (
          <Icon
            type='icondelete1'
            onClick={() => handleDelete(codes)}
            className={disabled ? css.disable : css.delete}
          />
        ) : null}
      </div>
      <div className={css.title}>{name}</div>
      {discountPrice && (
        <div className={css.discountIntroduce}>
          {getI18n(
            'allOrders.createneworder.component_discountselection_discountintroduce',
          )}
          :
          <span>
            {currency} -{discountPrice}
          </span>
        </div>
      )}
      {remainingQuota > 0 && (
        <div className={css.discountIntroduce}>
          {getI18n(
            'allOrders.createneworder.component_discountselection_Remainingquota',
          )}
          :<span>{remainingQuota}</span>
        </div>
      )}
      <div className={css.discountTime}>
        {validTo
          ? replaceI18nVariables(
              getI18n(
                'allOrders.createneworder.component_discountselection_valid',
              ),
              validFrom,
              validTo,
            )
          : replaceI18nVariables(
              getI18n(
                'allOrders.createneworder.component_discountselection_valid_noend',
              ),
              validFrom,
            )}
      </div>

      {giftSelection && (
        <div>
          <p className={css.productHeader}>
            {getI18n(
              'allOrders.createneworder.component_discountselection_selectedproduct',
            )}
          </p>
          <ProductItemsTable
            isGift={freeGift}
            maxSelection={maxSelection}
            disabled={disabled}
            currency={currency}
            rowKey={keyUuid}
            value={edit || !selectable ? productAll : checkedProduct}
            nonOperational={
              !edit || selectable === false || selectionType == 'Single'
            }
            onChange={handleProductChange}
            {...(edit && selectable !== false && { rowSelection })}
          />
          {edit && selectable !== false && (
            <Button
              type='primary'
              disabled={disabled}
              className={css.applyButton}
              onClick={handleApply}>
              {getI18n(
                'allOrders.createneworder.component_discountselection_apply',
              )}
            </Button>
          )}
          {!edit && selectable !== false && (
            <p
              className={disabled ? css.disableReselect : css.reselect}
              onClick={!disabled && handleEdit}>
              {getI18n(
                'allOrders.createneworder.component_discountselection_reselect',
              )}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(DiscountSelections);
